<template>
  <div>
    <div class="content-warp">
      <div class="content-item" v-for="(item, index) in data.list" :key="index" @click="handleClick(item.link)">
        <img class="content-img" :src="item.imgUrl" alt="" />
        <div class="content-text">
          <p class="sub-title">{{item.title}}</p>
          <p class="sub-text">{{item.text}}</p>
        </div>
      </div>
    </div>

    <div class="btn-warp" v-if="isBtn">
      <div class="more btn" :data-text="data.moreLabel" @click="handleClick(data.moreLink)"></div>
      <!-- <div class="refer btn">{{dataObj.referLabel}}</div> -->
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    data: VueTypes.object.def({}),
    isBtn: VueTypes.bool.def(false)
  },

  data () {
    return {

    }
  },

  methods: {
    handleClick (val) {
      window.open(val)
    }
  }
}
</script>

<style lang="scss" scoped>

.content-warp {
  position: relative; z-index: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn-warp {
  display: flex;
  justify-content: center;
}

.content-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  &:hover,
  &:active {
    cursor: pointer;

    & .content-text {
      & .sub-title {
        color: #437DFF;
      }
    }
  }

  & img {
    width: 250px; height: 137px;
  }

  & .content-text {
    width: 279px;
    margin: 4px 0 0 26px;
    font-size: 14px;

    & .sub-title {
      line-height: 30px;
      font-size: 18px; font-weight: 600;
      @include row(2);

      @include mobile {
        font-size: 13px;
        line-height: 18px;
      }
    }

    & .sub-text {
      margin-top: 17px;
      line-height: 26px;
      color: #828A92;
      @include row(2);
      font-size: 15px; font-weight: 400;

      @include mobile {
        margin-top: 9px;
        font-size: 11px;
        line-height: 16px;
      }
    }
  }
}

.content-img {
  @include mobile {
    flex-shrink: 0;
  }
}

.more {
  position: relative;
  width: 191px; height: 45px;
  background: url('~@/assets/transSave/resource/image/b3/f3/b3160a45454e274950eeceeec84a97f3.png') no-repeat;
  background-size: 100% auto;

  @include enlayoutInner {
    background-size: 100% 99%;
  }

  &:after {
    position: absolute; bottom: 3px;
    display: block;
    content: attr(data-text);
    width: 100%; height: 36px;

    @include enlayoutInner {
      bottom: 5px;
    }
  }
}

.btn {
  width: 191px; height: 45px;
  line-height: 35px;
  color: #2F302F;
  text-align: center;
  font-size: 16px; font-weight: 500;
  cursor: pointer;

  @include enlayoutInner {
    width: 300px;
  }
}

// .refer {
//   margin-left: 25px;
//   // background: linear-gradient(150deg,rgba(255, 0, 84, 1),rgba(43, 112, 251, 0.8));
//   width: 191px; height: 40px;
//   background: url('../../assets/img/developcourse/bg_course_r.png');
//   background-size: 100% auto;
// }

@include mobile {
  .content-item {
    & img {
      width: 140px; height: 77px;

      @include enlayoutInner{
        margin-top: 3px;
      }
    }

    & .content-text {
      width: auto;
      margin: 0 0 0 18px;

      & .sub-title {
        font-size: 15px;
      }

      & .sub-text {
        font-size: 12px;
        line-height: 1.5;
      }
    }
  }
  .btn-warp {
    flex-direction: column;

    & .btn {
      margin: 0 auto;

      @include enlayoutInner {
        width: 265px;
        font-size: 14px;
      }
    }

    & .refer {
      margin: 5px auto;
    }
  }
}

</style>
